import React from "react";
import { useLang } from "../context/LanguageContext";

export default function Legal({ kind = "privacy" }) {
  const { t } = useLang();
  const body = kind === "privacy" ? t("legal.privacy_body") : t("legal.terms_body");
  return (
    <div className="max-w-[820px] mx-auto px-5 lg:px-8 py-16" data-testid="legal-page">
      <div className="text-xs uppercase tracking-[0.2em] text-gold/80">Legal</div>
      <h1 className="font-display text-4xl text-white mt-2">{kind === "privacy" ? t("legal.privacy") : t("legal.terms")}</h1>
      <div className="mt-6 space-y-4 text-white/60 text-sm leading-relaxed">
        {body.map((p, i) => <p key={i}>{p}</p>)}
      </div>
    </div>
  );
}
